import React from "react";
import { typography } from "../styles/designSystem";
import { reveal } from "../styles/animations";

/**
 * Reusable centered page header with label, title, divider, and subtitle.
 *
 * @param {object} props
 * @param {React.Ref} props.sectionRef – ref from useInView
 * @param {boolean} props.visible – inView flag
 * @param {string} props.label – small uppercase label (e.g. "Portfolio")
 * @param {React.ReactNode} props.title – heading content (can include JSX for highlights)
 * @param {string} props.subtitle – paragraph below the divider
 * @param {string} [props.className] – additional wrapper classes
 */
const PageHeader = ({
  sectionRef,
  visible,
  label,
  title,
  subtitle,
  className = "",
}) => (
  <div
    ref={sectionRef}
    className={`text-center max-w-3xl mx-auto mb-16 md:mb-20 space-y-6 ${reveal(visible)} ${className}`}
  >
    <p className={`${typography.label} text-gray-400`}>{label}</p>

    <h1 className={`${typography.heading.h1} text-secondary`}>{title}</h1>

    <div className="flex justify-center">
      <div className="w-12 h-1 bg-gradient-to-r from-primary to-accent rounded-full" />
    </div>

    {subtitle && (
      <p className={`${typography.body.large} max-w-2xl mx-auto`}>{subtitle}</p>
    )}
  </div>
);

export default PageHeader;
